import { ImageTextIcon } from './ImageTextIcon';

/**
 * author: Google
 * id E404BB7C-724B-4390-9DE4-D08DA29B151A
 * name image-text
 * version: 5.6.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/image-text.svg
 * tags
 */
export const ImageDescriptionIcon = ImageTextIcon;
export default ImageDescriptionIcon